<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12">
        <iq-card>
          <!-- <template v-slot:headerTitle v-if="!propOpenedInModal">
            <h4 class="card-title">{{ cvCardTitle }}</h4>
          </template> -->
          <template v-slot:body>
            <form action="#" v-if="vmChangeCounsellorFormData && Object.keys(vmChangeCounsellorFormData).length > 0">
              <div class="form-row">
                <div class="col-md-12 mb-3">
                  <label for="validationcounsellor_id">{{ cvCounsellorLabel }}</label>
                  <input readonly v-model="vmChangeCounsellorFormData.counsellor_name" type="text" class="form-control" required/>
                </div>

               <div class="col-md-12 mb-3">
                  <label for="validationcounsellor_id">New Lead Strategist</label>
                 <multiselect
                  v-model="vmChangeCounsellorFormData.new_counsellor_id"
                  :options="counsellorObjList"
                  :multiple="false"
                  placeholder="Search counsellor"
                  label="user_name"
                  track-by="counsellor_user_id"
                />
                </div>

                <div class="col-md-12 mb-3">
                  <label for="validationslot_duration">{{ cvStudentNameLabel }}</label>&nbsp;<label class="primary-color font-size-16">*</label>
                  <input readonly v-model="vmChangeCounsellorFormData.stu_name" type="text" class="form-control" required/>
                </div>

                <div class="col-md-12 mb-3">
                  <label for="validationslot_duration">{{ cvStudentEmailLabel }}</label>&nbsp;<label class="primary-color font-size-16">*</label>
                  <input readonly v-model="vmChangeCounsellorFormData.stu_email" type="text" class="form-control" required />
                </div>

                <p class="ml-1">
                  <button :disabled="isNotAllowedToChangeCounsellor" type="button" class="btn btn-primary" @click="changeStrategist()">Modify</button>&nbsp;&nbsp;
                </p>
              </div>
            </form>
          </template>
        </iq-card>
      </b-col>
    </b-row>
    <b-toast
      v-model="showToast"
      name="Toast"
      :variant="toastVariant"
      :title="toastTitle"
    >
      <div v-html="toastMsg"></div>
    </b-toast>
  </b-container>
</template>

<script>
import { Spcms } from "../../../FackApi/api/Spcm.js"
import { SpcmCounsellors } from "../../../FackApi/api/SpcmCounsellor.js"
import Multiselect from "vue-multiselect"
import userPermission from "../../../Utils/user_permission.js"
import ApiResponse from "../../../Utils/apiResponse.js"

export default {
  name: "ChangeStrategist",
  components: {
    Multiselect
  },
  data () {
    return {
      cvCounsellorLabel: "Current Lead Strategist Name",
      cvStudentNameLabel: "Student Name",
      cvStudentEmailLabel: "Student Email",
      cvModules: "Modify",
      counsellorObjList: [],
      toastVariant: "default",
      toastTitle: "Invite User",
      toastMsg: null,
      showToast: false,
      vmChangeCounsellorFormData: {
        new_counsellor_id: null
      },
      isNotAllowedToChangeCounsellor: false
    }
  },
  props: {
    propUserObj: {
      type: Object,
      default: null
    },
    propPdtCode: {
      type: String,
      default: "gpaths"
    }
  },
  computed: {
    userData () {
      return this.$store.getters["User/userData"]
    }
  },
  mounted () {
    if (this.propUserObj) {
      let apiName = "spcm_strategist_edit"
      // 1. Check if the current user is part of the assigned counselor team
      const isUserInTeam = this.propUserObj.counselor_team && this.propUserObj.counselor_team.includes(this.userData.user_id)

      // 2. Updated Permission Logic:
      // Allow if: Admin OR (Counselor with permission) OR (Is Lead Counselor) OR (Is in the Counselor Team)
      if (!(this.userData.user_role == "USERROLE11111" || (this.userData.user_role == "USERROLE11118" && userPermission(this, this.userData, apiName) && isUserInTeam) || this.userData.user_id == this.propUserObj.counsellor_id)) {
        this.toastMsg = "Warning! You don't have permissions to change the lead strategist!"
        this.toastVariant = "warning"
        this.showToast = true
        console.log("User does not have permission to change counsellor.")
        this.isNotAllowedToChangeCounsellor = true
        this.$emit("emitCloseChangeCounselllor")
        return
      }
    }
    this.vmChangeCounsellorFormData = { ...this.propUserObj }
    this.getCounselorFilterList()
  },
  methods: {
    /**
     * change Strategist
     */
    async changeStrategist () {
      try {
        this.vmChangeCounsellorFormData.old_counsellor_id = this.propUserObj.counsellor_id
        this.vmChangeCounsellorFormData.modules = this.propPdtCode
        const selected = this.vmChangeCounsellorFormData.new_counsellor_id

        const newCounsellorIds = Array.isArray(selected)
          ? selected.map(c => c.counsellor_user_id)
          : selected
            ? [selected.counsellor_user_id]
            : []

        // Keep user_id as the requesting user, move its value to gide_user_id for the target student
        if (this.vmChangeCounsellorFormData.gide_user_id) {
          this.vmChangeCounsellorFormData.gide_user_id = this.vmChangeCounsellorFormData.gide_user_id
        }

        const payload = {
          ...this.vmChangeCounsellorFormData,
          new_counsellor_id: newCounsellorIds
        }

        const changeCounsellorResp = await Spcms.spcmStrategistEdit(this, payload)
        await ApiResponse.responseMessageDisplay(this, changeCounsellorResp)

        if (changeCounsellorResp.resp_status) {
          setTimeout(() => {
            this.$emit("emitCloseChangeCounselllor")
          }, 1000)
        }
      }
      catch (err) {
        console.error("Error in changeStrategist Err: ", err)
      }
    },
    /**
     * getCounselorFilterList
     */
    async getCounselorFilterList () {
      const counselorsListResp = await SpcmCounsellors.spcmCounsellorList()
      if (counselorsListResp.resp_status) {
        this.counsellorObjList = counselorsListResp.resp_data.data
      }
    }
  }
}
</script>

<style>

</style>
